/**
 * Windowの一番上にスクロールする
 */
export const returnTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

/**
 * 引数argがstring型の場合、小文字を大文字に変換して返す
 * @param {*} arg 
 * @returns 
 */
export const manualUpperCase = (arg) => {
  if(typeof arg === "string" || arg instanceof String){
    return arg.toUpperCase();
  }
  return arg;
}

/**
 * 引数argがstring型の場合、大文字を小文字に変換して返す
 * @param {*} arg 
 * @returns 
 */
 export const manualLowerCase = (arg) => {
  if(typeof arg === "string" || arg instanceof String){
    return arg.toLowerCase();
  }
  return arg;
}

/**
 * string型の場合trueを返す
 * @param {*} arg
 * @returns 
 */
export const isStringType = (arg) => {
  return (typeof arg === "string" || arg instanceof String);
}

/**
 * nullの場合trueを返す
 * 
 * @param {*} arg 
 * @returns 
 */
 export const isNull = (arg) => {
  return arg === null
}

/**
 * undefinedの場合trueを返す
 * 
 * @param {*} arg 
 * @returns 
 */
export const isUndefined = (arg) => {
  return (typeof arg === "undefined")
}

// 互換維持版: 配列も "object" と見なして true を返す。null安全。
export const isObject = (arg) => {
  if (arg == null) return false;               // null/undefined → false
  if (Array.isArray(arg)) return arg.length > 0;  // 配列 → 要素数で判定（従来互換）
  if (typeof arg === 'object') return Object.keys(arg).length > 0; // オブジェクト → キー数
  return false; // それ以外（数値/文字列/関数など）
}

// 配列だけ判定
export const isNonEmptyArray = (arg) =>
  Array.isArray(arg) && arg.length > 0;

// プレーンオブジェクトだけ判定
export const isNonEmptyPlainObject = (arg) =>
  !!arg && typeof arg === 'object' && !Array.isArray(arg) && Object.keys(arg).length > 0;

// 「配列 or オブジェクトに中身がある」を一発で判定したい場合
export const hasData = (arg) =>
  Array.isArray(arg) ? arg.length > 0
  : (arg != null && typeof arg === 'object' ? Object.keys(arg).length > 0 : false);

/**
 * 空/未入力判定：null/undefined/空文字/空白のみ を true
 */
export const isBlank = (v) =>
  v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

/**
 * 文字列正規化：NFKC + trim（引数が文字列以外ならそのまま返す）
 * - 全角/半角のゆらぎを抑止（例：丸括弧、英数、スペース）
 */
export const normalizeStr = (s) =>
  (typeof s === 'string' ? s.normalize('NFKC').trim() : s);

/**
 * contains 条件を安全に and配列へ追加
 * - 未入力（isBlank）や最小長未満は「条件を追加しない」
 * - bracketExpand: 丸括弧の全半角を OR で吸収（'( )' と '（ ）'）
 *  例: addContains(andArr, 'username', kw, { minLen: 2, bracketExpand: true })
 */
export const addContains = (
  andArr,
  field,
  value,
  { minLen = 1, bracketExpand = false } = {}
) => {
  let v = normalizeStr(value);

  // 条件を追加しない
  if (isBlank(v) || v.length < minLen) return; 

  if (bracketExpand && /[()（）]/.test(v)) {
    const vHalf = v.replace(/（/g, '(').replace(/）/g, ')');
    const vFull = v.replace(/\(/g, '（').replace(/\)/g, '）');
    andArr.push({ or: [ { [field]: { contains: vHalf } }, { [field]: { contains: vFull } } ] });
    return;
  }
  andArr.push({ [field]: { contains: v } });
};